import React, {useState, useEffect, useRef} from 'react'
import {usePopper} from 'react-popper'
import styled from 'styled-components'
import './styles.css'

const DropDownContent = styled.div`
  border: 2px solid rgba(255, 255, 255, 0.06) !important;
  background-color: #061823 !important;
  box-shadow: 0 0 12px 2px rgba(0, 0, 0, 0.60) !important;
`

export const DropdownContent = ({title, items, onSelect}) => {
  return (
      <>
        {title && <div className="dropdown-title">{title}</div>}
        <div className="flex flex-wrap text-center">
          {items.map((item, i) => (
              <div
                  key={i}
                  onClick={()=>onSelect(item.id)}
                  className="w-12 flex flex-col items-center justify-center h-20 space-y-1 dropdown-item cursor-pointer">
                {item.icon}
                <span className="text-xs">{item.title}</span>
              </div>
          ))}
        </div>
      </>
  )
}

const Dropdown = ({
  placement = 'bottom-start',
  button,
  children,
  width = 'w-full'
}) => {
  const [hidden, setHidden] = useState(true)

  const buttonRef = useRef(null)
  const dropdownRef = useRef(null)

  const {styles, attributes} = usePopper(
    buttonRef.current,
    dropdownRef.current,
    {
      placement: placement,
    }
  )

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        hidden ||
        buttonRef.current.contains(event.target) ||
        dropdownRef.current.contains(event.target)
      ) {
        return false
      }
      setHidden(!hidden)
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [hidden, dropdownRef, buttonRef])

  const handleDropdownClick = (e) => {
    e.preventDefault();
    setHidden(!hidden)
  }

  return (
    // <div className="hidden lg:flex relative">
    <div className="flex relative">
      <button.type {...button.props}
                   ref={buttonRef}
                   onClick={handleDropdownClick}
      />
      <div ref={dropdownRef} style={{...styles.popper, ...{width: '30rem'}}} {...attributes.popper}>
        <div
          style={styles.offset}
          className={`dropdown ${hidden ? '' : 'open'}`}>
          <DropDownContent className={`dropdown-content ${width} ${placement}`}>
            {children}
          </DropDownContent>
        </div>
      </div>
    </div>
  )
}

export default Dropdown
